module.exports = __webpack_public_path__ + "img/bench_240.1810b241.jpg";